import { Link } from "react-router-dom";
import { Tiles } from "@/components/motion/Tiles";
import { ArrowUpRight, ClipboardCheck, Truck, Wrench } from "lucide-react";
import { Item, Lines, Reveal, Stagger } from "@/components/motion/Reveal";

const SERVICES = [
  {
    n: "01",
    icon: Wrench,
    title: "Noleggio",
    text: "A freddo o con operatore, giornaliero, settimanale o mensile. Tariffe chiare, mezzi revisionati e assistenza durante tutto il noleggio.",
    to: "/servizi/noleggio",
    testId: "service-card-noleggio",
  },
  {
    n: "02",
    icon: Truck,
    title: "Trasporto",
    text: "Consegniamo e ritiriamo i mezzi direttamente nel tuo cantiere, in tutta la provincia di Catania e nella Sicilia orientale.",
    to: "/servizi/trasporto",
    testId: "service-card-trasporto",
  },
  {
    n: "03",
    icon: ClipboardCheck,
    title: "Consulenza",
    text: "Non sai quale mezzo ti serve? Descrivici il lavoro: ti consigliamo il mezzo giusto per altezza, sbraccio e spazi disponibili.",
    to: "/contatti",
    testId: "service-card-consulenza",
  },
];

export const Services = () => (
  <section className="bg-white py-24 sm:py-32" data-testid="services-section">
    <div className="container-x">
      <Reveal y={10}><p className="eyebrow flex items-center gap-3"><Tiles />Servizi</p></Reveal>
      <Lines as="h2" lines={["Non solo noleggio.", "Tutto quello che serve."]} className="display mt-4 text-4xl text-ink sm:text-5xl lg:text-6xl" />
      <Stagger className="mt-14 grid gap-px bg-ink/10 md:grid-cols-3" gap={0.12}>
        {SERVICES.map((s) => (
          <Item key={s.title} className="group relative bg-white p-8 transition-colors duration-500 hover:bg-ink sm:p-10">
            <Link to={s.to} className="absolute inset-0" aria-label={s.title} data-testid={s.testId} />
            <div className="flex items-center justify-between">
              <span className="font-mono text-xs text-ink/40 transition-colors group-hover:text-white/40">{s.n}</span>
              <s.icon className="h-6 w-6 text-blue-600 transition-colors group-hover:text-blue-500" strokeWidth={1.6} />
            </div>
            <h3 className="display mt-16 text-4xl text-ink transition-colors group-hover:text-white">{s.title}</h3>
            <p className="mt-4 text-sm leading-relaxed text-ink/60 transition-colors group-hover:text-white/60 sm:text-base">{s.text}</p>
            <span className="mt-8 inline-flex items-center gap-2 font-display text-sm font-bold uppercase tracking-wider text-ink transition-colors group-hover:text-white">
              Scopri <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </span>
          </Item>
        ))}
      </Stagger>
    </div>
  </section>
);
